import React,{useEffect} from 'react';
import style from './no-product-service-ideal.scss';
import { useSelector,useDispatch } from 'react-redux';
import {  toggleAddEditButtonAnimation } from '../../../actions/products'

const NoProductServiceIdeal = (props) => {
  const session = useSelector(state => state.session);
  const isOwner = session.user.loggedUser && session.user.loggedUser.userType == "OWNER";
  const isObeFromSSO = session.user.loggedUser && session.user.loggedUser?.subType == "OBE";
  const profileObject = session?.profileObject;  
  const dispatch = useDispatch();
  let imageUrl = style.prodserimg
  if (profileObject.SingleLabelWithSpace ==  'Product'){
    imageUrl = style.prodimg
  }else if (profileObject.SingleLabelWithSpace ==  'Service'){
    imageUrl = style.serimg
  }else {
    imageUrl = style.prodserimg
  }


  useEffect(() => {
      dispatch(
        toggleAddEditButtonAnimation({
          isAddEditButtonAnimation: true,
        })
      );
  }, []);

  return (
    <>
    <div className={`${style.noprowrap}`}>
      <div className={`${imageUrl}`}>

      </div>
      <div className={`${style.prodname}`}>{`Showcase Your ${profileObject?.PluralLabelWithSpace}`}</div>
      <div className={`${style.proddtl}`}>{`Add ${profileObject?.PluralLabelWithSpace} and grab attention of your customers`}</div>
      <div className={`${style.btnwrap}`}>
        { profileObject.isRE || profileObject.isSO || session.viaOmni ?
          <button 
            onClick={() => props.clickHandler('addProduct')}
          > 
            <span 
              className={`${style.addproducticon}`}
            /> 
              Add Product
          </button>
        : null
        }
        { profileObject.isSer || session?.viaOmni ? 
          <button
            onClick={() => props.clickHandler('addService')}
          > 
            <span 
              className={`${style.addserviceicon}`}
            />
            Add Service
          </button>
        : null
        }
      </div>
      
      <div className={`${style.otherlistwrap}`}>
        {isOwner || (isObeFromSSO && session.bulkUploadProfile) ? <span className={`${style.otherlist}`} onClick={() => props.clickHandler('bulkUpload')}>Bulk Upload</span> : null}
        {!session?.viaOmni ? <span className={`${style.otherlist}`} onClick={() => props.clickHandler('brochure')}>Add Brochure</span> : null}
        <span className={`${style.otherlist}`} onClick={() => props.clickHandler('photos')}>Add Photos</span>
        {!session?.viaOmni ? <span className={`${style.otherlist}`} onClick={() => props.clickHandler('jdGallery')}>Add from Jd Gallery</span> : null}
      </div>
    </div>
    </>
  )
}

export default NoProductServiceIdeal